module.exports = __webpack_public_path__ + "img/icon_map_2_off_101.415d154d.png";